import React, { Component } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getMonth, getYear,format } from 'date-fns';

import {eventCalendarListAction} from '../../actions/eventActions';
import { serverTimeAction} from '../../actions/commonActions';
import {converDateToLocal} from '../../utils/commonUtilities';
import * as types from '../../actions';

const localizer = momentLocalizer(moment)

class quoteCalendarView extends Component {

  constructor(props){
    super()
    // let dtVar = new Date(); 
    this.state = {
      month:'', 
      year:'',
      reloadCalendarView:0,
      defaultStartDate: new Date()
    }
  }

  goToBack = (toolbar) => {
    let {isEvent,applyFilter,filtersData} = this.props;
    toolbar.date.setMonth(toolbar.date.getMonth() - 1);
    let month= format(toolbar.date,'M');
    toolbar.onNavigate('prev');
    this.props.eventCalendarListAction({isEvent:isEvent,month:month,year:toolbar.date.getFullYear(),applyFilter:applyFilter,filtersData:filtersData});
    this.setState({month:month,year:toolbar.date.getFullYear()});
  }

  goToNext = (toolbar) => {
    let {isEvent,applyFilter,filtersData} = this.props;
    toolbar.date.setMonth(toolbar.date.getMonth() + 1);
    let month= format(toolbar.date,'M');
    toolbar.onNavigate('next');
    this.props.eventCalendarListAction({isEvent:isEvent,month:month,year:toolbar.date.getFullYear(),applyFilter:applyFilter,filtersData:filtersData});
    this.setState({month:month,year:toolbar.date.getFullYear()});
  }

    customToolbar = (toolbar) =>{
      return (
        <div className="rbc-toolbar">       
          <span className="rbc-toolbar-label">{toolbar.label}</span>
          <span className="rbc-btn-group">
            <button onClick={()=>this.goToBack(toolbar)}><i className="fa fa-angle-left"></i></button>
            <button onClick={()=>this.goToNext(toolbar)}><i className="fa fa-angle-right"></i></button>
          </span>
        </div>      
      )
    }

    eventDetail = (event)=>{
      let eventId = event.id;
      this.props.showQuoteDetails(eventId);
    }

    formatEventData(array){
      let {timeZone} = this.props;
      let event = [];
      if(array.length>0){
          array.map(item => {
              //let startTime = converDateToLocal(item.start_date,"+00:00",'hhmm');
              let eventObj = {};   
              eventObj['id'] = item.id;
              eventObj['title'] = item.title; // startTime+' '+item.title;       
              eventObj['start'] = converDateToLocal(item.start_date,"+00:00",'yyyymmddThhmmss','-'); 
              eventObj['end'] = converDateToLocal(item.end_date,"+00:00",'yyyymmddThhmmss','-'); 
              event.push(eventObj);
              return event;
          });          
      }
      return event;
    }

    componentDidUpdate(prevProps) {
        let {month,year} = this.state;
        const {activity,isEvent,reloadCalendarView,applyFilter,filtersData} = this.props;   
        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                let defaultStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                this.setState({defaultStartDate:defaultStartDate})
                let month = getMonth(new Date(defaultStartDate.valueOf()));
                let year  = getYear(new Date(defaultStartDate.valueOf()));
                this.setState({month,year}, () => {
                    this.props.eventCalendarListAction({isEvent:isEvent,month:month+1,year:year,applyFilter:applyFilter,filtersData:filtersData});
                })
                
            }
        }
        if(Number(reloadCalendarView) > Number(this.state.reloadCalendarView)) {
          this.setState({reloadCalendarView:reloadCalendarView}, () => {
            this.props.eventCalendarListAction({isEvent:isEvent,month:Number(month)+1,year:year,applyFilter:applyFilter,filtersData:filtersData});
          });
        }

        if (activity !== prevProps.activity) {
            if(activity===types.EVENT_ADD_SUCCESS){
              this.props.eventCalendarListAction({isEvent:isEvent,month:Number(month)+1,year:year,applyFilter:applyFilter,filtersData:filtersData});
            }
        }
    }

    componentDidMount(){
        this.props.serverTimeAction();
        let {isEvent,applyFilter,filtersData} = this.props;
        
    }

    render(){
      let {calendarEvents,timeZone} = this.props;
      let eventsList = this.formatEventData(calendarEvents);    
      let todayDate = this.state.defaultStartDate;
  
        return(
            <>
                <Calendar
                    localizer={localizer}
                    views={['month']}
                    defaultView = "month"
                    defaultDate = {new Date()}
                    getNow={() => todayDate}
                    components={{
                      toolbar: this.customToolbar                   
                    }}
                    events={eventsList}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 800 }}
                    popup={true}
                    onSelectEvent={event => this.eventDetail(event)}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
  return {     
    calendarEvents:state.event.calendarEvents,
    status:state.event.status,
    activity:state.event.activity,
    serverTimeList: state.serverTimeList.serverTimeList,
    serverTimeListActivity : state.serverTimeList.serverTimeListActivity
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    eventCalendarListAction:eventCalendarListAction,
    serverTimeAction:serverTimeAction
  },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(quoteCalendarView);